import {
    PlanWithVersionsResponse,
    PlanVersionQuery,
    PlanData,
    PlanVersionsResponse,
    PlanQuery,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/plan-version';

export class PlanVersionApi {
    public static async getList(params?: PlanVersionQuery | PlanQuery): Promise<PlanWithVersionsResponse> {
        const res = await axios.get<PlanWithVersionsResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async getPlanVersions(id: string): Promise<PlanData[]> {
        const res = await axios.get<PlanVersionsResponse>(`${BASE_URL}/${id}`);

        return res.data.plan.versions;
    }
}
